// ** User List Component
import Table from './Table';
// ** Styles
import '@styles/react/apps/app-users.scss';

const Notifications = () => {
  return (
    <div className="app-user-list">
      <Table />
    </div>
  );
};

export default Notifications;
